import { isArray, isNumber, isString, isValidModel } from '@models';

export interface INavigationTree {
  name: string;
  id: number;
  pid: number;
  group?: INavigationTree[];
}

export const isNavigationTree = (obj: any): obj is INavigationTree => {
  return isValidModel<INavigationTree>(obj, {
    name: isString,
    id: isNumber,
    pid: isNumber,
    group: (value: any) => isArray(value) && (value[0] ? isNavigationTree(value[0]) : true),
  });
};
